import React, { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import SectionTitle from "./SectionTitle";
import "./HotelCards.css";
import { REACT_APP_API_URL } from "../env";
import { useGetHotelsQuery } from "../api/hotelApi";


const HotelCards = () => {
  const navigate = useNavigate();
  const { data: hotels = [], isLoading, isError } = useGetHotelsQuery();

 const prioritizedHotels = useMemo(() => {
  const priorityLocations = ["Netarhat", "Betla", "Patratu", "Ranchi"];

  return [...hotels].sort((a, b) => {
    const getPriority = (hotel) => {
      const index = priorityLocations.findIndex((loc) =>
        hotel.UnitName.includes(loc)
      );
      return index === -1 ? Infinity : index;
    };

    return getPriority(a) - getPriority(b);
  });
}, [hotels]);

  if (isLoading) {
    return <div>Loading hotels...</div>;
  }

  if (isError) {
    return <div>Failed to load hotels.</div>;
  }

  return (
    <section className="hotel-area py-5 rel z-1">
      <div className="responsive-wrapper">
        <div className="row justify-content-between align-items-center pb-10">
          <div
            className="col-lg-12 d-flex justify-content-center align-items-center m-15"
            style={{ flexWrap: "wrap", textAlign: "center" }}
          >
            <div className="d-flex align-items-center flex-wrap justify-content-center arrow-hover-wrapper">
              <h2
                className="hotel-book-headline mb-0 me-3"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
                  fontFamily: "'EB Garamond', serif",
                  fontStyle: "italic",
                  letterSpacing: "1.5px",
                  color: "#FFFFFF",
                  margin: 0,
                }}
              >
                Unveil Comfort & Luxury Stay at JTDC Hotels
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="responsive-wrapper">
        <div className="row justify-content-center g-4">
          {prioritizedHotels.slice(0, 6).map((hotel) => (
            <div
              className="col-12 col-sm-10 col-md-8 col-lg-5"
              key={hotel.PropertyID}
              id="hotel-card"
            >
              <div className="destination-item style-three bgc-lighter">
                <div className="image position-relative">
                  <img
                    src={`${REACT_APP_API_URL}/PropertyUploadsDocuments/${hotel.Photo}`}
                    alt={hotel.UnitName}
                    onClick={() => navigate(`/hotel/${hotel.PropertyID}`)}
                    className="hotel-image-responsive"
                    style={{ cursor: "pointer" }}
                  />
                  {["Betla", "Patratu", "Netarhat", "Ranchi"].some((location) =>
                    hotel.UnitName.includes(location)
                  ) && (
                      <span
                        className="badge bg-primary text-white"
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px",
                          padding: "5px 10px",
                          fontSize: "12px",
                          borderRadius: "5px",
                        }}
                      >
                        Top Choice
                      </span>
                    )}
                </div>

                <div className="content p-3" style={{ width: "100%" }}>
                  <span
                    className="location"
                    style={{ display: "block", marginBottom: "10px" }}
                  >
                    <i className="fas fa-map-marker-alt me-2" />
                    {hotel.LocationName}
                  </span>

                  <h5
                    style={{
                      fontSize: "18px",
                      marginBottom: "15px",
                      lineHeight: "1.5",
                    }}
                  >
                    <Link to={`/hotel/${hotel.PropertyID}`}>
                      {hotel.UnitName
                        ? hotel.UnitName.replace(/hotel/i, "").trim()
                        : "No Name Available"}
                    </Link>
                  </h5>

                  <ul
                    className="list-style-one"
                    style={{ marginBottom: "20px" }}
                  >
                    <li style={{ color: "black", fontSize: "14px" }}>
                      <i className="fas fa-bed me-2 fs-6" />
                      {hotel.TotalRooms} Rooms
                    </li>
                    <li style={{ color: "black", fontSize: "14px" }}>
                      <i className="fas fa-mobile-alt me-2 fs-6" />
                      {hotel.MobileNo}
                    </li>
                    <li style={{ color: "black", fontSize: "14px" }}>
                      <i className="fas fa-bath me-2 fs-6" />
                      Wash room
                    </li>
                    <li style={{ color: "black", fontSize: "14px" }}>
                      <i className="fas fa-parking me-2 fs-6" />
                      Parking
                    </li>
                  </ul>

                  <div
                    className="d-flex justify-content-between align-items-center pt-3 border-md-0 border-top mt-0 mt-md-3"
                    style={{
                      flexWrap: "nowrap",
                      gap: "1rem",
                    }}
                  >
                    <span
                      className="price mb-0"
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      ₹ {hotel.PriceRange?.replace(/\.00|₹/g, "") || "N/A"}
                    </span>
                    <Link
                      to={`/hotel/${hotel.PropertyID}`}
                      className="btn btn-outline-warning btn-sm rounded-pill px-3 py-1 text-uppercase fw-semibold"
                      style={{
                        fontSize: "13px",
                        color: "black",
                        letterSpacing: "0.5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="responsive-wrapper d-flex justify-content-center mt-0 mt-md-2">
        <button
          type="button"
          className="btn explore-btn"
          onClick={() => navigate("/allhotel")}
        >
          Check All Hotels <span className="arrow">→</span>
        </button>
      </div>
    </section>
  );
};

export default HotelCards;
